import { mapQuestionIndexToPercentage, mapEnumValueToDisplayable } from "../shared/model/GameUtils";
import { MAX_QUESTION_INDEX } from "../shared/model/GameUtils";

export default function AnswerComponent({answers, index}) {
    const onepQuestion = "glow secondary-light"
    return(
        <div className="horizontal-container">
            <span className={index === MAX_QUESTION_INDEX ? onepQuestion : ""}>
                {mapQuestionIndexToPercentage(index)}%&nbsp;:   
            </span>
            <span className={`full-width center ${index === MAX_QUESTION_INDEX && answers && answers[index] === "RIGHT" ? onepQuestion : ""}` }>
                {mapEnumValueToDisplayable(answers ? answers[index] : "")}
            </span>
        </div>
    )
}